import { CanvasSkeleton } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton";

export const DesktopSkeletonContents = () => {
  return (
    <div className="flex flex-col gap-4 mx-5">
      <div className="flex items-center justify-center my-6">
        <CanvasSkeleton className="h-1 w-9/12" />
      </div>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex gap-4">
          <CanvasSkeleton className="w-full aspect-square flex flex-col justify-end px-3 py-3 gap-2">
            <CanvasSkeleton className="h-4 w-full" />
            <CanvasSkeleton className="h-4 w-1/2" />
          </CanvasSkeleton>
          <CanvasSkeleton className="w-full aspect-square flex flex-col justify-end px-3 py-3 gap-2">
            <CanvasSkeleton className="h-4 w-full" />
            <CanvasSkeleton className="h-4 w-1/2" />
          </CanvasSkeleton>
          <CanvasSkeleton className="w-full aspect-square flex flex-col justify-end px-3 py-3 gap-2">
            <CanvasSkeleton className="h-4 w-full" />
            <CanvasSkeleton className="h-4 w-1/2" />
          </CanvasSkeleton>
          <CanvasSkeleton className="w-full aspect-square flex flex-col justify-end px-3 py-3 gap-2">
            <CanvasSkeleton className="h-4 w-full" />
            <CanvasSkeleton className="h-4 w-1/2" />
          </CanvasSkeleton>
        </div>
      ))}
    </div>
  );
};
